app.service('deliveryAddressDetails', function (orderConfig, orderClass) {

	let $self;
	let config;

	function init() {
		config = orderConfig.getData();
		setElements();
		setEvents();
	}

	function setElements() {
		$self = $('#delivery-address input:not(#delivery-flat-number)');
	}

	function setEvents() {
		$.cityAutocomplete('#delivery-zip-code', '#delivery-city-name', config.streetValidateEnable ? '#delivery-street' : false);
	}

	function render() {
		const deliveryEqualsHome = config.deliveryInfo.deliveryEqualsHome;
		orderClass.toggle("hide-another-delivery-address", deliveryEqualsHome);
		$self.ignore(deliveryEqualsHome);
	}

	return {
		init,
		render
	};
});